import { render, staticRenderFns } from "./IcoEnvelope.vue?vue&type=template&id=bed108d0"
import script from "./IcoEnvelope.vue?vue&type=script&lang=js"
export * from "./IcoEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports